module.exports = __webpack_public_path__ + "static/media/email.846d3957.jpg";